import { Envelope, EnvelopeOpen } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

import useConversationUpdates from "../datahooks/useConversationUpdates";

import type { Conversation } from "../types";

interface ConversationActionsProps {
  conversation: Conversation;
}

export default function ConversationActions({
  conversation,
}: ConversationActionsProps) {
  const {
    conversation_urn: conversationUrn,
    unread_count: unreadCount,
    owner: accountId,
  } = conversation;

  const { markAsRead, markAsUnread } = useConversationUpdates();

  const handleReadStatus = (isRead: boolean) => {
    if (isRead) {
      markAsRead({ accountId, conversationUrn });
      return;
    }

    markAsUnread({ accountId, conversationUrn });
  };

  return (
    <Button
      intent="iconOnly"
      variant="secondary-black"
      size="xs"
      onClick={(e) => {
        e.stopPropagation();
        handleReadStatus(unreadCount > 0);
      }}
    >
      {unreadCount > 0 ? (
        <EnvelopeOpen />
      ) : (
        <div className="relative">
          <Envelope />
          <span className="absolute right-0 top-0 size-1 rounded-full bg-purple-500 outline outline-white" />
        </div>
      )}
    </Button>
  );
}
